/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { addressFragment } from './addressFragment.gql';
export type personFragment_CreditApplicationPerson_address_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export type personFragment = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: personFragment_CreditApplicationPerson_address_CreditApplicationAddress | null };

export const personFragment = gql`
    fragment personFragment on CreditApplicationPerson {
  id
  firstName
  lastName
  title
  dob
  email
  passportCountry
  passportNumberLastFour
  passportExpiration
  passportNumberLength
  phoneNumber
  ssnLastFour
  verifiedPhoneNumber
  address {
    ...addressFragment
  }
}
    ${addressFragment}`;